import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable } from 'rxjs';
import { QueryBuilderService } from './ag-grid/query-builder/query-builder.service';
import { DeliveryTimeApiModel } from 'app/models/delivery-time-api.model';
import { DataRequest } from './ag-grid/query-builder/models/query-builder-request.model';

@Injectable()
export class MwDeliveryTimesApiService {
  constructor(
    private http: MwHttpService,
    private queryBuilderService: QueryBuilderService
  ) {}

  private apiEndpoint = `/transport/v1/Companies/{companyId}/DeliveryTimes`;

  get(request: DataRequest): Observable<DeliveryTimeApiModel[]> {
    let query = this.queryBuilderService.buildOdataQuery(request, false);
    query = query.length > 0 ? '?' + query : query;
    return this.http.authGet<DeliveryTimeApiModel[]>(this.apiEndpoint + query);
  }

  create(time: DeliveryTimeApiModel): Observable<number> {
    return this.http.authPost<number>(this.apiEndpoint, {
      body: time,
    });
  }

  update(time: DeliveryTimeApiModel): Observable<DeliveryTimeApiModel> {
    return this.http.authPut<DeliveryTimeApiModel>(this.apiEndpoint, {
      body: time,
    });
  }

  delete(time: DeliveryTimeApiModel): Observable<any> {
    return this.http.authDelete(this.apiEndpoint, {
      body: [time],
    });
  }

  deleteList(time: DeliveryTimeApiModel[]): Observable<any> {
    return this.http.authDelete(this.apiEndpoint, {
      body: time,
    });
  }
}
